// import ChartV5 from '../../pages/imagen-positiva/ChartV5';
import ChartApi from '../../pages/imagen-positiva/ChartApi';

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            {/* <ChartV5 /> */}
            <ChartApi piePagina={'Años 2018 a 2021 corresponden a promedios anuales. Se visualiza la aprobación de figuras políticas con 30% o más de conocimiento.'}  />
          </div>
        </div>
      </div>
    </div>
  )
}
